document.addEventListener('DOMContentLoaded', () => {
  const fixRiseSpinner = () => {
    document.querySelectorAll('.Rise-popup-spinner svg').forEach(svg => {
      if (!svg.hasAttribute('aria-hidden')) {
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');
      }
    });
  };

  fixRiseSpinner();
  new MutationObserver(fixRiseSpinner).observe(document.body, {
    childList: true,
    subtree: true
  });

  document.querySelectorAll('img[alt]').forEach(img => {
    if (img.alt.toLowerCase().includes('hcaptcha')) {
      img.setAttribute('alt', '');
      img.setAttribute('aria-hidden', 'true');
    }
  });

  document.querySelectorAll('.header__menu-disclosure').forEach(details => {
    const summary = details.querySelector('summary');

    summary.addEventListener('focus', () => {
      details.setAttribute('open', '');
      details.setAttribute('aria-expanded', 'true');
    });

    details.addEventListener('focusout', (e) => {
      if (!details.contains(e.relatedTarget)) {
        details.removeAttribute('open');
        details.setAttribute('aria-expanded', 'false');
      }
    });
  });


});


(() => {
  const clean = (root = document) => {
    root.querySelectorAll('.promo-carousel h4.promo-card-title').forEach(h => {
      if (h.getAttribute('role') === 'heading') h.removeAttribute('role');
      if (h.hasAttribute('aria-level')) h.removeAttribute('aria-level');
    });
  };

  window.addEventListener('DOMContentLoaded', () => clean());

  const obs = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const n of m.addedNodes) {
        if (n.nodeType === 1) clean(n);
      }
      if (m.type === 'attributes' && m.target) clean(m.target.parentNode || document);
    }
  });

  obs.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['role', 'aria-level']
  });
})();


(() => {
  function fixCookieButtonAccessibility() {
    const btn = document.querySelector('.pd-floating-icon__open');
    if (!btn) return;

    btn.setAttribute('aria-label', 'Open cookie settings');

    const img = btn.querySelector('img');
    if (img) {
      img.setAttribute('alt', '');
    }
  }

  fixCookieButtonAccessibility();
  const observer = new MutationObserver(() => {
    fixCookieButtonAccessibility();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();


(() => {
  function fixTolstoyImages() {
    document.querySelectorAll('.tolstoy-product-tile-image').forEach(img => {
      const container = img.closest('.tolstoy-product-tile');

      const title = container?.querySelector('.tolstoy-product-tile-title')?.innerText?.trim();

      if (title && img.getAttribute('alt') === title) {
        img.setAttribute('alt', '');
      }
    });
  }

  fixTolstoyImages();

  const observer = new MutationObserver(() => {
    fixTolstoyImages();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();


(() => {
  function fixTolstoyVideoAccessibility() {

    // Fix video
    document.querySelectorAll('.tolstoy-carousel-video').forEach(video => {
      const label = video.getAttribute('aria-label') || '';

      if (label.match(/\.(mov|mp4)/i) || label.includes('Slider')) {
        video.setAttribute('aria-label', 'Product video');
      }
    });

    // Fix img
    document.querySelectorAll('.tolstoy-carousel-image').forEach(img => {
      const alt = img.getAttribute('alt') || '';

      if (alt.match(/\.(mov|mp4|jpg)/i) || alt.includes('Slider')) {
        img.setAttribute('alt', '');
      }
    });
  }

  fixTolstoyVideoAccessibility();

  const observer = new MutationObserver(() => {
    fixTolstoyVideoAccessibility();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();


(() => {
  function fixBannerSVG(root = document) {
    const svgs = root.querySelectorAll('.pd-cp-ui-close-top svg');

    svgs.forEach(svg => {
      if (!svg.hasAttribute('aria-hidden')) {
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');
      }
    });
  }

  fixBannerSVG();

  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            fixBannerSVG(node);
          }
        });
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();


(() => {
  function fixLinks() {
    const cookieBanner = document.querySelector('#cookieconsent\\:desc');
    if (!cookieBanner) return;

    const links = cookieBanner.querySelectorAll('a[target]');

    links.forEach(link => {
      const target = link.getAttribute('target');

      if (target !== null && target.trim() === '') {
        link.removeAttribute('target');
      }
    });
  }

  fixLinks();

  const observer = new MutationObserver(() => {
    fixLinks();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['target']
  });

})();

(() => {
  function fixCookieDialog() {
    const dialog = document.querySelector('#pandectes-banner');

    if (!dialog) return;

    const isHidden = dialog.style.display === 'none';

    if (isHidden) {
      dialog.removeAttribute('aria-describedby');
    } else {
      dialog.setAttribute('aria-describedby', 'cookieconsent:desc');
    }
  }

  fixCookieDialog();

  const observer = new MutationObserver(fixCookieDialog);

  observer.observe(document.body, {
    attributes: true,
    subtree: true,
    attributeFilter: ['style', 'class']
  });
})();


(() => {
  function fixTolstoyButtons() {
    const buttons = document.querySelectorAll('[data-tolstoy-element*="previous-button"]');

    buttons.forEach(btn => {
      const isHidden =
        btn.style.display === 'none' ||
        btn.getAttribute('data-visibility') === 'hidden';

      if (isHidden) {
        btn.removeAttribute('aria-label');
      } else {
        btn.setAttribute('aria-label', 'Show previous story');
      }
    });
  }

  fixTolstoyButtons();

  const observer = new MutationObserver(fixTolstoyButtons);

  observer.observe(document.body, {
    attributes: true,
    subtree: true,
    attributeFilter: ['style', 'data-visibility']
  });
})();


(() => {
  function fixTolstoyStories() {
    const stories = document.querySelectorAll('[data-tolstoy-element*="stories-tile"]');

    stories.forEach(el => {
      el.setAttribute('aria-label', 'Play story');

      const innerButtons = el.querySelectorAll('[role="button"]');

      innerButtons.forEach(btn => {
        if (btn !== el) {
          btn.setAttribute('aria-hidden', 'true');
        }
      });
    });
  }

  fixTolstoyStories();

  const observer = new MutationObserver(fixTolstoyStories);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();


(() => {
  function fixTolstoyArrows() {
    const prevButtons = document.querySelectorAll('[data-tolstoy-element*="previous-button"]');
    const nextButtons = document.querySelectorAll('[data-tolstoy-element*="next-button"]');

    prevButtons.forEach(btn => {
      const isHidden = btn.style.display === 'none';

      if (isHidden) {
        btn.removeAttribute('aria-label');
      } else {
        btn.setAttribute('aria-label', 'Show previous story');
      }
    });

    nextButtons.forEach(btn => {
      const isHidden = btn.style.display === 'none';

      if (isHidden) {
        btn.removeAttribute('aria-label');
      } else {
        btn.setAttribute('aria-label', 'Show next story');
      }
    });
  }

  fixTolstoyArrows();

  const observer = new MutationObserver(fixTolstoyArrows);

  observer.observe(document.body, {
    attributes: true,
    subtree: true,
    attributeFilter: ['style']
  });
})();


(function fixTolstoyADA() {
  const fixElements = () => {

    const elements = document.querySelectorAll('[aria-hidden="true"]');

    elements.forEach(el => {
      const isFocusable =
        el.hasAttribute('tabindex') ||
        el.getAttribute('role') === 'button' ||
        el.tagName === 'A' ||
        el.tagName === 'BUTTON';

      if (isFocusable) {
        el.removeAttribute('aria-hidden');
      }
    });


    const fakeButtons = document.querySelectorAll('div[role="button"]');

    fakeButtons.forEach(el => {
      if (!el.hasAttribute('tabindex')) {
        el.setAttribute('tabindex', '0');
      }

      el.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          el.click();
        }
      });
    });


    const innerButtons = document.querySelectorAll(
      'div[role="button"] div[role="button"]'
    );

    innerButtons.forEach(el => {
      el.setAttribute('aria-hidden', 'true');
      el.removeAttribute('tabindex');
    });
  };


  fixElements();


  const observer = new MutationObserver(() => {
    fixElements();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();


(function fixNestedInteractiveTolstoy() {
  const fix = () => {
    const tiles = document.querySelectorAll('[data-tolstoy-element*="stories-tile"]');

    tiles.forEach(tile => {
      const innerButton = tile.querySelector('[data-tolstoy-element*="play-button-container"]');

      if (innerButton) {
        innerButton.removeAttribute('role');
        innerButton.removeAttribute('tabindex');
        innerButton.setAttribute('aria-hidden', 'true');
        innerButton.style.pointerEvents = 'none';
      }
    });
  };

  fix();

  const observer = new MutationObserver(fix);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();


document.addEventListener('DOMContentLoaded', function () {
  function fixPixelIframes() {
    const iframes = document.querySelectorAll('iframe[id^="web-pixel-sandbox-"]:not([title])');

    iframes.forEach(function (iframe) {
      const iframeId = iframe.getAttribute('id') || 'unknown';
      iframe.setAttribute('title', `Tracking pixel sandbox ${iframeId}`);
    });
  }

  fixPixelIframes();

  const observer = new MutationObserver(function () {
    fixPixelIframes();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
});


document.addEventListener('DOMContentLoaded', function () {
  function fixWishlistAccessibility() {
    const container = document.querySelector('#swym-anchor');

    if (container) {
      container.removeAttribute('role');
      container.removeAttribute('aria-label');
    }

    const link = document.querySelector('#notepad-anchor-title');

    if (link) {
      link.removeAttribute('aria-label');
    }
  }

  fixWishlistAccessibility();

  const observer = new MutationObserver(function () {
    fixWishlistAccessibility();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});


document.addEventListener('DOMContentLoaded', function () {

  function updateMegaMenu(details) {
    const menu = details.querySelector('.mega-menu');
    if (!menu) return;

    if (details.hasAttribute('open')) {
      menu.setAttribute('tabindex', '0');
    } else {
      menu.removeAttribute('tabindex');
    }
  }


  const allDetails = document.querySelectorAll('details.header__menu-disclosure');

  allDetails.forEach((details) => {
    updateMegaMenu(details);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'open') {
          updateMegaMenu(details);
        }
      });
    });

    observer.observe(details, {
      attributes: true,
      attributeFilter: ['open']
    });
  });

});

document.addEventListener('DOMContentLoaded', function () {
  function hideDecorativeIcons(root = document) {
    root.querySelectorAll('i.fa, i.swym-icon').forEach((el) => {
      el.setAttribute('aria-hidden', 'true');
    });
  }

  hideDecorativeIcons();

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;

        if (node.matches('i.fa, i.swym-icon')) {
          node.setAttribute('aria-hidden', 'true');
        }

        hideDecorativeIcons(node);
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});


document.addEventListener('DOMContentLoaded', function () {

  function hasNewTabWarning(el) {
    const ariaLabel = (el.getAttribute('aria-label') || '').toLowerCase();
    const text = (el.textContent || '').toLowerCase();

    const hiddenWarning = [...el.querySelectorAll('.sr-only, .visually-hidden')]
      .some(node => {
        const t = (node.textContent || '').toLowerCase();
        return t.includes('new tab') || t.includes('new window');
      });

    return (
      ariaLabel.includes('new tab') ||
      ariaLabel.includes('new window') ||
      text.includes('new tab') ||
      text.includes('new window') ||
      hiddenWarning
    );
  }

  function fixBlankLinksAccessibility(root = document) {
    root.querySelectorAll('a[target="_blank"]').forEach(el => {

      if (el.dataset.skipLinkAccessibility === 'true') {
        return;
      }

      if (hasNewTabWarning(el)) return;

      if (!el.querySelector('[data-new-tab-warning]')) {
        const span = document.createElement('span');
        span.className = 'visually-hidden';
        span.setAttribute('data-new-tab-warning', 'true');
        span.textContent = ' (opens in a new tab)';
        el.appendChild(span);
      }

      const ariaLabel = el.getAttribute('aria-label') || '';
      if (!ariaLabel.toLowerCase().includes('new tab')) {
        const base = ariaLabel || el.textContent.trim() || 'Link';
        el.setAttribute('aria-label', `${base} (opens in a new tab)`);
      }

    });
  }

  fixBlankLinksAccessibility();

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          fixBlankLinksAccessibility(node);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});


document.addEventListener('DOMContentLoaded', function () {

  function fixDialogAccessibility() {
    document.querySelectorAll('cart-note-dialog[role="dialog"]').forEach(el => {

      if (el.getAttribute('data-a11y-fixed')) return;

      const id = el.id ||
        el.getAttribute('data-custom-aria-labelledby') ||
        `dialog-${Math.random().toString(36).slice(2)}`;

      el.id = id;

      const labelId = `cart-note-title-${id}`;

      const label = el.querySelector('label');

      if (label) {
        label.id = labelId;
        el.setAttribute('aria-labelledby', labelId);
      } else {
        el.setAttribute('aria-label', 'Order note');
      }

      el.setAttribute('aria-modal', 'true');
      el.setAttribute('data-a11y-fixed', 'true');
      el.removeAttribute('data-custom-aria-labelledby');
    });
  }


  fixDialogAccessibility();


  const observer = new MutationObserver(() => {
    fixDialogAccessibility();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});


(() => {
  const map = {
    wg: "White Gold",
    yg: "Yellow Gold",
    rg: "Rose Gold",
    br: "Black Rhodium"
  };

  const updateSwatches = () => {
    document.querySelectorAll('.color-swatch .sr-only').forEach(el => {
      const value = el.textContent.trim().toLowerCase();

      if (map[value]) {
        el.textContent = map[value];
      }
    });
  };

  updateSwatches();

  const observer = new MutationObserver(() => {
    updateSwatches();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();


(() => {
  const fixUpsellProductImageLinks = () => {
    document.querySelectorAll(".rt-upsell-product-image-link").forEach((link) => {
      const firstImg = link.querySelector("img[alt]");
      const productName = firstImg?.getAttribute("alt")?.trim();

      if (productName) {
        link.setAttribute("aria-label", `View ${productName} product`);
      }

      const images = link.querySelectorAll("img");

      images.forEach((img, index) => {
        if (index > 0) {
          img.setAttribute("alt", "");
          img.setAttribute("aria-hidden", "true");
        }
      });
    });
  };

  fixUpsellProductImageLinks();

  new MutationObserver(fixUpsellProductImageLinks).observe(document.body, {
    childList: true,
    subtree: true
  });
})();


(() => {
  const fixUpsellCarouselButtons = () => {
    document
      .querySelectorAll(".rt-upsell-carousel-section .rt-upsell-carousel-prev")
      .forEach((button) => {
        button.setAttribute("aria-label", "Show previous recommended product");
      });

    document
      .querySelectorAll(".rt-upsell-carousel-section .rt-upsell-carousel-next")
      .forEach((button) => {
        button.setAttribute("aria-label", "Show next recommended product");
      });
  };

  fixUpsellCarouselButtons();

  new MutationObserver(fixUpsellCarouselButtons).observe(document.body, {
    childList: true,
    subtree: true
  });
})();


(() => {
  const fixTolstoyButtons = () => {
    document
      .querySelectorAll(".tolstoy-stories-previous-button")
      .forEach((button) => {
        button.setAttribute("aria-label", "Show previous story");
      });

    document
      .querySelectorAll(".tolstoy-stories-next-button")
      .forEach((button) => {
        button.setAttribute("aria-label", "Show next story");
      });
  };

  fixTolstoyButtons();

  new MutationObserver(fixTolstoyButtons).observe(document.body, {
    childList: true,
    subtree: true
  });
})();


(() => {
  const fixTolstoyCloseButtons = () => {
    document
      .querySelectorAll(".minimize-tolstoy-modal, ._mobileFeedCloseButton_itciw_241")
      .forEach((button) => {
        button.setAttribute("aria-label", "Close Tolstoy video modal");
      });
  };

  fixTolstoyCloseButtons();

  new MutationObserver(fixTolstoyCloseButtons).observe(document.body, {
    childList: true,
    subtree: true
  });
})();


(() => {
  const observer = new MutationObserver((mutations, obs) => {
    const btn = document.querySelector('#predictive-search-form button[is="dialog-close-button"]');

    if (btn) {
      btn.setAttribute("aria-label", "Close dialog");

      const sr = btn.querySelector(".sr-only");
      if (sr) sr.textContent = "Close dialog";

      obs.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

(() => {
  const fixTolstoyButtons = () => {
    document
      .querySelectorAll('.tolstoy-stories-previous-button:not([data-a11y-fixed])')
      .forEach((btn) => {
        btn.setAttribute("aria-label", "Show previous story");
        btn.setAttribute("data-a11y-fixed", "true");
      });

    document
      .querySelectorAll('.tolstoy-stories-next-button:not([data-a11y-fixed])')
      .forEach((btn) => {
        btn.setAttribute("aria-label", "Show next story");
        btn.setAttribute("data-a11y-fixed", "true");
      });
  };

  fixTolstoyButtons();

  const interval = setInterval(fixTolstoyButtons, 500);
  setTimeout(() => clearInterval(interval), 5000);
})();


(() => {
  const fixWishlistButtons = () => {
    document
      .querySelectorAll('.swym-add-to-wishlist')
      .forEach((btn) => {
        const text = btn
          .querySelector('.swym-wishlist-cta')
          ?.textContent.trim();

        if (!text) return;

        btn.setAttribute("aria-label", text);

        const tooltipText = btn.querySelector(".swym-tooltip-text");
        if (tooltipText) {
          tooltipText.textContent = text;
        }

        btn.setAttribute("data-a11y-fixed", "true");
      });
  };

  fixWishlistButtons();

  const interval = setInterval(fixWishlistButtons, 500);
  setTimeout(() => clearInterval(interval), 5000);
})();


(() => {
  const fixDeprecatedSwymIconTags = () => {
    document
      .querySelectorAll("i.swym-icon:not([data-a11y-fixed])")
      .forEach((icon) => {
        const span = document.createElement("span");

        [...icon.attributes].forEach((attr) => {
          span.setAttribute(attr.name, attr.value);
        });

        span.setAttribute("data-a11y-fixed", "true");
        span.innerHTML = icon.innerHTML;

        icon.replaceWith(span);
      });
  };

  fixDeprecatedSwymIconTags();

  const interval = setInterval(fixDeprecatedSwymIconTags, 500);
  setTimeout(() => clearInterval(interval), 5000);
})();


(() => {
  function replaceExtraH1InsideTargetSection() {
    const h1List = document.querySelectorAll("h1");

    if (h1List.length < 2) return;

    const targetSection = document.querySelector(
      "section .section-header.justify-self-center.text-center"
    );

    if (!targetSection) return;

    const h1 = targetSection.querySelector("h1");

    if (!h1) return;

    const h2 = document.createElement("h2");

    Array.from(h1.attributes).forEach(attr => {
      h2.setAttribute(attr.name, attr.value);
    });

    h2.innerHTML = h1.innerHTML;

    h1.replaceWith(h2);
  }

  document.addEventListener("DOMContentLoaded", replaceExtraH1InsideTargetSection);

  const observer = new MutationObserver(() => {
    replaceExtraH1InsideTargetSection();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();


(() => {
  function fixShogunLightboxImageAlt() {
    const img = document.querySelector(
      ".shg-lightbox .shg-lightbox-image-container img.shg-lightbox-image"
    );

    if (!img) return;

    img.setAttribute("alt", "");
    img.setAttribute("role", "presentation");
    img.setAttribute("aria-hidden", "true");
  }

  document.addEventListener("DOMContentLoaded", () => {
    fixShogunLightboxImageAlt();

    const observer = new MutationObserver(() => {
      fixShogunLightboxImageAlt();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
})();


(() => {
  function deepQuerySelectorAll(selector, root = document) {
    const results = [];

    function search(node) {
      if (!node) return;

      if (node.querySelectorAll) {
        results.push(...node.querySelectorAll(selector));
      }

      const allElements = node.querySelectorAll ? node.querySelectorAll("*") : [];

      allElements.forEach(el => {
        if (el.shadowRoot) {
          search(el.shadowRoot);
        }
      });
    }

    search(root);

    return results;
  }

  function fixShopSvgAccessibleName() {
    const svgs = deepQuerySelectorAll('svg[role="img"]');

    svgs.forEach(svg => {
      const titleText = svg.querySelector("title")?.textContent?.trim();

      if (titleText !== "Shop") return;

      const modal = svg.closest('[data-testid="authorize-modal"]');

      if (!modal) return;

      if (!svg.getAttribute("aria-label") && !svg.getAttribute("aria-labelledby")) {
        svg.setAttribute("aria-label", "Shop");
      }
    });
  }

  fixShopSvgAccessibleName();

  document.addEventListener("DOMContentLoaded", () => {
    fixShopSvgAccessibleName();

    const observer = new MutationObserver(() => {
      fixShopSvgAccessibleName();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  });

})();


(function () {
  function getFieldText(field) {
    const id = field.getAttribute('id') || '';
    const name = field.getAttribute('name') || '';
    const type = field.getAttribute('type') || '';
    const dataType = field.getAttribute('data-type') || '';
    const placeholder = field.getAttribute('placeholder') || '';

    let labelText = '';

    if (id) {
      const label = document.querySelector(`label[for="${CSS.escape(id)}"]`);
      labelText = label?.textContent || '';
    }

    return [
      id,
      name,
      type,
      dataType,
      placeholder,
      labelText
    ]
      .join(' ')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getAutocompleteValue(field) {
    const text = getFieldText(field);
    const fieldType = field.getAttribute('type');

    if (fieldType === 'hidden') return null;
    if (fieldType === 'submit') return null;
    if (fieldType === 'button') return null;
    if (fieldType === 'checkbox') return null;
    if (fieldType === 'radio') return null;
    if (fieldType === 'file') return null;

    if (
      text.includes('first name') ||
      text.includes('firstname') ||
      text.includes('given name')
    ) {
      return 'given-name';
    }

    if (
      text.includes('last name') ||
      text.includes('lastname') ||
      text.includes('surname') ||
      text.includes('family name')
    ) {
      return 'family-name';
    }

    if (
      text.includes('email') ||
      text.includes('e-mail')
    ) {
      return 'email';
    }

    if (
      text.includes('phone') ||
      text.includes('telephone') ||
      text.includes('mobile')
    ) {
      return 'tel';
    }

    if (
      text.includes('full name') ||
      text.includes('your name') ||
      text.match(/\bname\b/)
    ) {
      return 'name';
    }

    return null;
  }

  function fixGloboAutocomplete() {
    const forms = document.querySelectorAll('.globo-form-app form');

    forms.forEach(form => {
      const fields = form.querySelectorAll('input, textarea, select');

      fields.forEach(field => {
        const autocompleteValue = getAutocompleteValue(field);

        if (!autocompleteValue) return;

        field.setAttribute('autocomplete', autocompleteValue);
        field.setAttribute('data-a11y-autocomplete', autocompleteValue);

        if (field.tagName === 'INPUT' && autocompleteValue === 'email') {
          field.setAttribute('type', 'email');
        }

        if (field.tagName === 'INPUT' && autocompleteValue === 'tel') {
          field.setAttribute('type', 'tel');
        }
      });
    });
  }

  fixGloboAutocomplete();

  const observer = new MutationObserver(fixGloboAutocomplete);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();


document.addEventListener('DOMContentLoaded', () => {
  const SEARCH_INPUT_SELECTOR = '#header-search';
  const SEARCH_ROOT_SELECTOR = 'header-search';
  const STATUS_ID = 'predictive-search-status';

  let lastMessage = '';
  let debounceTimer = null;
  let rootObserver = null;
  let bodyObserver = null;

  const getSearchInput = () => {
    return document.querySelector(SEARCH_INPUT_SELECTOR);
  };

  const getSearchRoot = () => {
    return document.querySelector(SEARCH_ROOT_SELECTOR);
  };

  const getPredictiveSearch = () => {
    return document.querySelector('#header-predictive-search');
  };

  const ensureStatusRegion = () => {
    let statusRegion = document.querySelector(`#${STATUS_ID}`);

    if (statusRegion) return statusRegion;

    const form = document.querySelector('#predictive-search-form');

    if (!form) return null;

    statusRegion = document.createElement('div');
    statusRegion.id = STATUS_ID;
    statusRegion.className = 'visually-hidden';
    statusRegion.setAttribute('role', 'status');
    statusRegion.setAttribute('aria-live', 'polite');
    statusRegion.setAttribute('aria-atomic', 'true');

    form.insertAdjacentElement('afterend', statusRegion);

    const input = getSearchInput();

    if (input) {
      const describedBy = input.getAttribute('aria-describedby') || '';

      if (!describedBy.includes(STATUS_ID)) {
        input.setAttribute(
          'aria-describedby',
          `${describedBy} ${STATUS_ID}`.trim()
        );
      }
    }

    return statusRegion;
  };

  const getVisibleCount = (selector, root) => {
    return Array.from(root.querySelectorAll(selector)).filter((element) => {
      return !element.closest('[hidden]') && element.offsetParent !== null;
    }).length;
  };

  const updatePredictiveSearchStatus = () => {
    const input = getSearchInput();
    const predictiveSearch = getPredictiveSearch();
    const statusRegion = ensureStatusRegion();

    if (!input || !predictiveSearch || !statusRegion) {
      return;
    }

    const query = input.value.trim();

    if (!query) {
      statusRegion.textContent = '';
      lastMessage = '';
      return;
    }

    const productsCount = getVisibleCount(
      '.predictive-search__products product-card, .predictive-search__products .horizontal-product-card',
      predictiveSearch
    );

    const collectionsCount = getVisibleCount(
      '.predictive-search__collections a',
      predictiveSearch
    );

    const suggestionsCount = getVisibleCount(
      '.predictive-search__suggestions a',
      predictiveSearch
    );

    const totalResults = productsCount + collectionsCount + suggestionsCount;

    const message = `${totalResults} results available for ${query}`;

    if (message === lastMessage) return;

    statusRegion.textContent = '';

    window.setTimeout(() => {
      statusRegion.textContent = message;
      lastMessage = message;
    }, 50);
  };

  const scheduleUpdate = () => {
    window.clearTimeout(debounceTimer);

    debounceTimer = window.setTimeout(() => {
      updatePredictiveSearchStatus();
    }, 250);
  };

  const bindInputEvents = () => {
    const input = getSearchInput();

    if (!input || input.dataset.adaSearchBound === 'true') return;

    input.dataset.adaSearchBound = 'true';

    input.addEventListener('input', scheduleUpdate);
    input.addEventListener('keyup', scheduleUpdate);
    input.addEventListener('search', scheduleUpdate);
    input.addEventListener('change', scheduleUpdate);
  };

  const observeSearchRoot = () => {
    const searchRoot = getSearchRoot();

    if (!searchRoot) return;

    if (rootObserver) {
      rootObserver.disconnect();
    }

    rootObserver = new MutationObserver((mutations) => {
      bindInputEvents();
      ensureStatusRegion();
      scheduleUpdate();
    });

    rootObserver.observe(searchRoot, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['hidden', 'style', 'class', 'open', 'slot'],
    });

  };

  const observeBodyForReRender = () => {
    if (bodyObserver) return;

    bodyObserver = new MutationObserver(() => {
      const searchRoot = getSearchRoot();

      if (!searchRoot) return;

      bindInputEvents();
      ensureStatusRegion();

      if (!rootObserver) {
        observeSearchRoot();
      }
    });

    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  };

  bindInputEvents();
  ensureStatusRegion();
  observeSearchRoot();
  observeBodyForReRender();

  window.addEventListener('load', () => {
    bindInputEvents();
    ensureStatusRegion();
    observeSearchRoot();
    scheduleUpdate();
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const pauseButtons = document.querySelectorAll('.announcement-bar__pause-button');

  pauseButtons.forEach((button) => {
    const carouselId = button.getAttribute('aria-controls');
    const carousel = document.getElementById(carouselId);

    if (!carousel || !carousel.player) return;

    const srText = button.querySelector('.sr-only');
    const visibleText = button.querySelector('[aria-hidden="true"]');

    button.addEventListener('click', () => {
      const isPaused = button.getAttribute('aria-pressed') === 'true';

      if (isPaused) {
        carousel.player.start();

        button.setAttribute('aria-pressed', 'false');
        button.setAttribute('aria-label', 'Pause announcement carousel');

        if (srText) srText.textContent = 'Pause announcement carousel';
        if (visibleText) visibleText.textContent = 'Pause';
      } else {
        carousel.player.stop();

        button.setAttribute('aria-pressed', 'true');
        button.setAttribute('aria-label', 'Play announcement carousel');

        if (srText) srText.textContent = 'Play announcement carousel';
        if (visibleText) visibleText.textContent = 'Play';
      }
    });
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const fixKlaviyoCountryCombobox = () => {
    document
      .querySelectorAll('#downshift-0-menu [role="option"] img[aria-label], #downshift-0-menu [role="option"] img[title]')
      .forEach((img) => {
        img.setAttribute('aria-hidden', 'true');
        img.setAttribute('alt', '');
        img.removeAttribute('aria-label');
        img.removeAttribute('title');
      });
  };

  fixKlaviyoCountryCombobox();

  const observer = new MutationObserver(fixKlaviyoCountryCombobox);

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const focusableSelector = [
    'a[href]',
    'button:not([disabled]):not([tabindex="-1"])',
    'textarea:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  const isVisible = (el) => {
    const style = window.getComputedStyle(el);

    return (
      el.offsetWidth > 0 &&
      el.offsetHeight > 0 &&
      style.visibility !== 'hidden' &&
      style.display !== 'none'
    );
  };

  const getOpenPandectesDialog = () => {
    const cmp = document.querySelector('pandectes-cmp[data-active-instance="true"]');

    if (!cmp || !cmp.shadowRoot) return null;

    return [...cmp.shadowRoot.querySelectorAll('dialog[open], .dialog[data-open="true"]')]
      .find(isVisible);
  };

  const trapPandectesFocus = (event) => {
    if (event.key !== 'Tab') return;

    const dialog = getOpenPandectesDialog();

    if (!dialog) return;

    const focusableElements = [...dialog.querySelectorAll(focusableSelector)]
      .filter(isVisible);

    if (!focusableElements.length) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    const activeElement = dialog.getRootNode().activeElement || document.activeElement;

    if (event.shiftKey && activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
      return;
    }

    if (!event.shiftKey && activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  };

  document.addEventListener('keydown', trapPandectesFocus, true);
});

document.addEventListener('DOMContentLoaded', () => {
  const getSkipTarget = () => {
    return (
      document.querySelector('a[href="#MainContent"]') ||
      document.querySelector('.skip-to-content-link') ||
      document.querySelector('#SkipToContent') ||
      document.querySelector('main') ||
      document.body
    );
  };

  const moveFocusToTop = () => {
    const target = getSkipTarget();

    if (!target) return;

    const naturallyFocusable = target.matches(
      'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );

    if (!naturallyFocusable && !target.hasAttribute('tabindex')) {
      target.setAttribute('tabindex', '-1');
    }

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });

    target.focus({ preventScroll: true });
  };

  const watchPandectesDialog = () => {
    const cmp = document.querySelector('pandectes-cmp[data-active-instance="true"]');

    if (!cmp || !cmp.shadowRoot) return;

    const shadowRoot = cmp.shadowRoot;

    let wasOpen = Boolean(
      shadowRoot.querySelector('dialog[open], .dialog[data-open="true"]')
    );

    const observer = new MutationObserver(() => {
      const isOpen = Boolean(
        shadowRoot.querySelector('dialog[open], .dialog[data-open="true"]')
      );

      if (wasOpen && !isOpen) {
        setTimeout(moveFocusToTop, 50);
        setTimeout(moveFocusToTop, 300);
      }

      wasOpen = isOpen;
    });

    observer.observe(shadowRoot, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['open', 'data-open', 'style', 'class']
    });
  };

  const initPandectesFocusReturn = () => {
    const cmp = document.querySelector('pandectes-cmp[data-active-instance="true"]');

    if (cmp?.shadowRoot) {
      watchPandectesDialog();
      return;
    }

    const bodyObserver = new MutationObserver(() => {
      const cmp = document.querySelector('pandectes-cmp[data-active-instance="true"]');

      if (cmp?.shadowRoot) {
        bodyObserver.disconnect();
        watchPandectesDialog();
      }
    });

    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  };

  initPandectesFocusReturn();
});


document.addEventListener('DOMContentLoaded', () => {
  const getVisibleText = (el) => {
    return el?.textContent?.trim().replace(/\s+/g, ' ') || '';
  };

  const isVisible = (el) => {
    if (!el) return false;

    const style = window.getComputedStyle(el);

    return (
      el.offsetWidth > 0 &&
      el.offsetHeight > 0 &&
      style.display !== 'none' &&
      style.visibility !== 'hidden'
    );
  };

  const getKlaviyoDialogTitleText = (dialog) => {
    const richTextElements = [
      ...dialog.querySelectorAll('.klaviyo-form-richtext span, .klaviyo-form-richtext p')
    ].filter((el) => isVisible(el) && getVisibleText(el));

    const titleElement = richTextElements.find((el) => {
      const style = window.getComputedStyle(el);
      const fontSize = parseFloat(style.fontSize);

      return fontSize >= 24;
    });

    return getVisibleText(titleElement || richTextElements[0]);
  };

  const updateKlaviyoDialogLabel = () => {
    const dialogs = document.querySelectorAll('[role="dialog"][aria-modal="true"]');

    dialogs.forEach((dialog) => {
      const isKlaviyoPopup =
        dialog.querySelector('[data-testid="POPUP"]') ||
        dialog.querySelector('.klaviyo-form') ||
        (dialog.getAttribute('aria-label') || '').toLowerCase().includes('popup form');

      if (!isKlaviyoPopup) return;

      const titleText = getKlaviyoDialogTitleText(dialog);

      if (!titleText) return;

      dialog.setAttribute('aria-label', titleText);
      dialog.removeAttribute('aria-labelledby');
    });
  };

  updateKlaviyoDialogLabel();

  const observer = new MutationObserver(updateKlaviyoDialogLabel);

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

document.addEventListener('DOMContentLoaded', () => {
  let lastPopupTrigger = null;
  let openedDialog = null;
  let isRestoringFocus = false;

  document.querySelectorAll('.buttonPopup').forEach((button) => {
    button.addEventListener('click', () => {
      lastPopupTrigger = button;
    });
  });

  function getKlaviyoDialog() {
    return document.querySelector('[role="dialog"][aria-modal="true"] .klaviyo-form')
      ?.closest('[role="dialog"][aria-modal="true"]') || null;
  }

  function restoreFocus() {
    if (!lastPopupTrigger) return;

    if (document.body.contains(lastPopupTrigger)) {
      lastPopupTrigger.focus();
    }

    lastPopupTrigger = null;
    openedDialog = null;
    isRestoringFocus = false;
  }

  const observer = new MutationObserver(() => {
    const currentDialog = getKlaviyoDialog();

    if (currentDialog && !openedDialog) {
      openedDialog = currentDialog;
    }

    if (openedDialog && !openedDialog.isConnected && !isRestoringFocus) {
      isRestoringFocus = true;

      setTimeout(() => {
        restoreFocus();
      }, 100);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

document.addEventListener('DOMContentLoaded', () => {
  function addKlaviyoEmailVisualLabel() {
    const emailInput = document.querySelector('.klaviyo-form input[type="email"][name="email"]');

    if (!emailInput) return;

    const inputId = emailInput.getAttribute('id');

    if (!inputId) return;

    if (document.querySelector(`label[for="${inputId}"]`)) return;

    const label = document.createElement('label');

    label.setAttribute('for', inputId);
    label.className = 'ada-klaviyo-email-label';
    label.textContent = 'Email';

    label.setAttribute(
      'style',
      `
        display: block;
        margin-bottom: 6px;
        font-size: 12px;
        color: rgb(55, 63, 71);
        font-family: Poppins-Klaviyo-Hosted, Arial, 'Helvetica Neue', Helvetica, sans-serif;
        font-weight: 400;
        font-style: normal;
        line-height: 1.4;
        text-align: left;
      `
    );

    emailInput.insertAdjacentElement('beforebegin', label);
  }

  addKlaviyoEmailVisualLabel();

  const observer = new MutationObserver(addKlaviyoEmailVisualLabel);

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});


document.addEventListener('DOMContentLoaded', () => {
  let shadowObserver = null;

  function updatePandectesLearnMoreLinks() {
    const cmp = document.querySelector('pandectes-cmp');

    if (!cmp || !cmp.shadowRoot) return;

    cmp.shadowRoot.querySelectorAll('.links a[href*="/policies/privacy-policy"]').forEach((link) => {

      const text = link.textContent?.trim().replace(/\s+/g, ' ') || '';

      if (!/^learn more$/i.test(text)) return;

      link.setAttribute('aria-label', 'Learn more about our privacy policy');
      link.setAttribute('title', 'Learn more about our privacy policy');
    });

    if (!shadowObserver) {
      shadowObserver = new MutationObserver(updatePandectesLearnMoreLinks);

      shadowObserver.observe(cmp.shadowRoot, {
        childList: true,
        subtree: true,
      });
    }
  }

  updatePandectesLearnMoreLinks();

  const bodyObserver = new MutationObserver(updatePandectesLearnMoreLinks);

  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
});


document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', (event) => {
    const media = event.target.closest('[data-clickable-product-media]');

    if (!media) return;

    const productCard = media.closest('product-card');

    if (!productCard) return;

    const productLink = productCard.querySelector('a.product-title[href]');

    if (!productLink) return;

    productLink.click();
  });
});


(() => {
  function cleanText(text) {
    return text?.trim().replace(/\s+/g, ' ') || '';
  }

  function updateTolstoyProductAccessibility(root = document) {
    const productTiles = root.querySelectorAll('.tolstoy-product-tile');

    productTiles.forEach((tile) => {
      const title = cleanText(
        tile.querySelector('.tolstoy-product-tile-title')?.textContent
      );

      const price = cleanText(
        tile.querySelector('.tolstoy-product-tile-price')?.textContent
      );

      const control = tile.querySelector('[role="button"][tabindex]');

      if (!control || !title) return;

      const labelParts = [title];

      if (price) {
        labelParts.push(`Price ${price}`);
      }

      labelParts.push('opens in a new tab');

      control.setAttribute('role', 'link');
      control.setAttribute('aria-label', labelParts.join(', '));

      if (!control.hasAttribute('tabindex')) {
        control.setAttribute('tabindex', '0');
      }

      control.removeAttribute('aria-pressed');
      control.removeAttribute('aria-expanded');

      if (!control.dataset.adaTolstoyLinkFixed) {
        control.dataset.adaTolstoyLinkFixed = 'true';

        control.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            control.click();
          }
        });
      }
    });

    const productPanels = root.querySelectorAll('.tolstoy-product-content');

    productPanels.forEach((panel) => {
      const firstProductTitle = cleanText(
        panel.querySelector('.tolstoy-product-tile-title')?.textContent
      );

      const expandButton = panel.querySelector('.tolstoy-product-tile-arrow');

      if (!expandButton) return;

      const isExpanded = expandButton.getAttribute('aria-expanded') === 'true';

      const actionText = isExpanded ? 'Collapse' : 'Expand';

      const label = firstProductTitle
        ? `${actionText} products for ${firstProductTitle} video`
        : `${actionText} products for this video`;

      expandButton.setAttribute('aria-label', label);
      expandButton.setAttribute('title', label);
    });

    const videos = root.querySelectorAll('.tolstoy-carousel-video');

    videos.forEach((video, index) => {
      const tile = video.closest('.tolstoy-carousel-tile, [data-tolstoy-tile-key]');

      const firstProductTitle = cleanText(
        tile?.querySelector('.tolstoy-product-tile-title')?.textContent
      );

      const label = firstProductTitle
        ? `Stephanie Sale Picks video featuring ${firstProductTitle}`
        : `Stephanie Sale Picks product video ${index + 1}`;

      video.setAttribute('aria-label', label);
      video.setAttribute('title', label);
    });
  }

  updateTolstoyProductAccessibility();

  const observer = new MutationObserver(() => {
    updateTolstoyProductAccessibility();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-expanded', 'data-is-expanded', 'style', 'class']
  });
})();


(() => {
  let previousSelectedFilters = [];

  function cleanText(text) {
    return text?.trim().replace(/\s+/g, ' ') || '';
  }

  function ensureFilterStatusRegion() {
    let status = document.querySelector('#collection-filter-status');

    if (status) return status;

    status = document.createElement('div');
    status.id = 'collection-filter-status';
    status.className = 'sr-only';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');

    document.body.appendChild(status);

    return status;
  }

  function getSelectedFilters() {
    const selectedMap = new Map();

    document
      .querySelectorAll('rt-filters input[type="checkbox"]:checked')
      .forEach((input) => {
        const label = cleanText(input.closest('label')?.textContent);

        if (!label) return;

        const key = label.toLowerCase().replace(/\s+/g, ' ').trim();

        selectedMap.set(key, label);
      });

    return Array.from(selectedMap.values());
  }

  function getSelectedFiltersText(selectedFilters) {
    return selectedFilters.length
      ? `Selected filters: ${selectedFilters.join(', ')}`
      : 'No filters selected';
  }

  function getProductCount() {
    return document.querySelectorAll(
      '.product-card, .product-item, [data-product-card], .product-list__item'
    ).length;
  }

  function getFilterAction(previousFilters, currentFilters) {
    if (previousFilters.length && !currentFilters.length) {
      return 'All filters cleared';
    }

    const removedFilters = previousFilters.filter(
      (filter) => !currentFilters.includes(filter)
    );

    if (removedFilters.length === 1) {
      return `Filter ${removedFilters[0]} removed`;
    }

    if (removedFilters.length > 1) {
      return `Filters removed: ${removedFilters.join(', ')}`;
    }

    return '';
  }

  function announceFilterResults() {
    const status = ensureFilterStatusRegion();

    const currentSelectedFilters = getSelectedFilters();
    const selectedFiltersText = getSelectedFiltersText(currentSelectedFilters);
    const productCount = getProductCount();

    const actionText = getFilterAction(previousSelectedFilters, currentSelectedFilters);

    const message = actionText
      ? `${actionText}. ${selectedFiltersText}. ${productCount} products found.`
      : `${selectedFiltersText}. ${productCount} products found.`;

    status.textContent = '';

    setTimeout(() => {
      status.textContent = message;
    }, 100);

    previousSelectedFilters = currentSelectedFilters;
  }

  previousSelectedFilters = getSelectedFilters();

  document.addEventListener('collection:updated', () => {
    announceFilterResults();
  });
})();